module.exports = __webpack_public_path__ + "fa-regular-400.svg?416d58293e221c2b4b8f34c1531d5dfd";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/fontAwesome-5/webfonts/fa-regular-400.svg
// module id = 365
// module chunks = 0